import { BpmnModel, BpmnModelHelper, StartEvent } from "@edp-pmf/bpmn-model";

export class StartActivity extends StartEvent {
  static Clr_Type_ID: string = "bpm.StartEvent";
  ClrTypeID = StartActivity.Clr_Type_ID;

  constructor(model: BpmnModel) {
    super(model);
  }

  ResetBeforeLoadFrom() {
    super.ResetBeforeLoadFrom();
  }

  ConvertToJsonObject(): any {
    let obj = super.ConvertToJsonObject();

    return obj;
  }

  LoadFromJsonObject(obj: any) {
    super.LoadFromJsonObject(obj);
  }

  NewInstance() {
    return new StartActivity(this.Model);
  }

  clone(): StartActivity {
    const clone = super.clone() as StartActivity;

    return clone;
  }
}
BpmnModelHelper.RegisterElementType(new StartActivity(new BpmnModel()));
